/**
 * Created by Adam on 17/08/2016.
 */

(function (angular) {
    'use strict';

    if (!angular) return;

    angular
        .module('autocompleteCitySearch', ['ngMaterial'])
        .directive('mdFocus', ['$timeout', function ($timeout) {
            return {
                restrict: 'A',
                link: function (scope, element, attributes) {
                    $timeout(function () {
                        angular.element(element[0].querySelector("input")).bind("focus", function () {
                            $timeout(function () {
                                scope.$eval(attributes.mdFocus);
                            }, 100);
                        });
                    }, 0);
                }
            };
        }]).directive('mdBlur', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                $timeout(function () {
                    angular.element(element[0].querySelector("input")).bind("blur", function () {
                        $timeout(function () {
                            scope.$eval(attributes.mdBlur);
                        }, 100);
                    });
                }, 0);
            }
        };
    }])

        .controller('autoComplete', ['$log', '$http', '$scope', '$window', function autoComplete($log,
                                                                                                 $http,
                                                                                                 $scope,
                                                                                                 $window) {

            $scope.init = function (homeUrl, currentSearch, placeholder) {
                $scope.homeUrl = homeUrl;
                $scope.searchText = currentSearch || '';
                $scope.placeholderSelector = placeholder;
                $scope.placeholderSelectorLocation = placeholder;
            };

            $scope.symbolDict = {
                'CONTINENT': "language",
                'CITY': "location_city",
                'LANDMARK': "local_see",
                'USER': "person",
                'BAR': "local_bar",
                'PUB': "local_bar",
                'CAFE': "local_cafe",
                'NATIONAL_PARK': "park_tree",
                'GROUP_OF_ISLANDS ': "island",
                'ISLAND': "island",
                'RESTAURANT': "local_dining",
                'ART': "color_lens",
                'LOCATION': "language",
                'COUNTRY': "language",
                'GROUP_OF_COUNTRIES':"language",
                'STATE': "language",
                'DISTRICT': "location_on",
                'SEARCH': 'search'

            };

            var self = this;
            self.simulateQuery = false;
            self.isDisabled = false;
            self.querySearch = querySearch;
            self.selectedItemChange = chooseAction;
            $scope.startWrite = false;
            $scope.isFocused = false;

            // ******************************
            // Internal methods
            // ******************************
            /**
             * Search for repos... use $timeout to simulate
             * remote dataservice call.
             */
            function querySearch(inputPrefix) {
                //send tracking user search
                trackCTA('top_nav_auto_complete_search', inputPrefix);
                var resultArray = [{name: inputPrefix, nodeType: "SEARCH"}];
                //Get all the result from the api and insert them to array
                return getAutoCompleteResult(inputPrefix).then(function (response) {

                    if (response.data != null) {

                        angular.forEach(response.data.data, function (item, i) {
                            if (item.articleCounter > 0)
                                resultArray.push({
                                    name: item.name,
                                    id: item.id,
                                    url: item.url,
                                    nodeType: item.nodeType,
                                    parentName: item.parent.name,
                                    parentNodeType: item.parent.nodeType
                                });
                        });
                    }
                    trackCTANoInteraction('top_nav_auto_complete_result', resultArray.length.toString());
                    return resultArray;
                });
            }

            function chooseAction(item) {
                if (item.nodeType === "SEARCH") {
                    trackCTA('top_nav_auto_complete_choose', $scope.searchText + ' (search)');
                    trackConversion('top_nav_auto_complete_choose',location.href ,$scope.searchText + ' (search)');
                    $scope.searchSelector(item.name);
                }
                else {
                    trackCTA('top_nav_auto_complete_choose', $scope.searchText + ' (location)');
                    trackConversion('top_nav_auto_complete_choose',location.href, $scope.searchText + ' (location)');
                    $window.location.assign($scope.homeUrl + item.url);
                }

            }

            function getAutoCompleteResult(prefixInput) {
                return $http.get(window.TCTServer.api + 'v2/autoComplete?s=' + prefixInput + '&limit=5&nodeTypes=CONTINENT,GROUP_OF_COUNTRIES,COUNTRY,STATE,CITY,DISTRICT');
            }

            $scope.getParentName = function (item) {
                if (item.parentNodeType != "CONTINENT" && item.parentNodeType != "WORLD")
                    return item.parentName;
                return '';
            };

            $scope.getSymbolText = function (item) {
            };

            $scope.searchSelector = function (inputToSearch) {
                var searchUrl = $scope.homeUrl + '?s=' + encodeURIComponent(inputToSearch);
                $window.location.assign(searchUrl);
            };

            $scope.checkIfEnterPressed = function (keyEvent) {
                if (keyEvent.which === 13 && $scope.searchText != '') {
                    trackCTA('top_nav_auto_complete_choose', $scope.searchText + ' (search)');
                    trackConversion('top_nav_auto_complete_choose',location.href, $scope.searchText + ' (search)');
                    $scope.searchSelector($scope.searchText);
                }
            };

            $scope.trackOnFocus = function () {
                $scope.isFocused = true;
                trackCTA('top_nav_auto_complete_focus');
                $scope.startWrite = true;
                $scope.placeholderSelector = "e.g. London, art in Japan, or food...";
            };

            $scope.onBlur = function () {
                $scope.isFocused = false;
                $scope.placeholderSelector = $scope.placeholderSelectorLocation;
            };

            $scope.trackFirstType = function () {
                if ($scope.startWrite) {
                    trackCTA('top_nav_auto_complete_start_type');
                    $scope.startWrite = false;
                }
                $scope.firstEnterToInput = false;
            }
        }]);

    angular.element(document).ready(function () {
        var elements = document.getElementsByClassName('city-search');

        for (var i = 0; i < elements.length; i++) {
            var element = elements[i],
                wrapped = angular.element(element);

            angular.bootstrap(wrapped, ['autocompleteCitySearch']);
        }
    });

})(window['angular']);